module.exports = "data:video/mp4;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJtZWRpYS9hbmltYXRlLXZpZGVvLjdiY2RhMjFlLm1wNCI7"